import React, {useCallback} from "react";
import {BroadcastUtils, ProductItem, VirtualWindow} from "filkersjs-model/dist";
import {useCreation} from "ahooks";
import {useTranslation} from "react-i18next";
import WhatsApp from "src/components/logo/WhatsApp";
import ReactGA from 'react-ga';


export interface FooterProps {
    vw: VirtualWindow,
    item?: ProductItem,
}


const Footer = ({vw, item}: FooterProps) => {

    const {t} = useTranslation("virtualWindow");
    const itemData = useCreation(() => {
        if (item === undefined) {
            return undefined;
        }
        return BroadcastUtils.findLocalizedItemData(item);
    }, [item])

    const contactText = useCreation(() => {
        if (vw === undefined) {
            return undefined;
        } else if (itemData === undefined) {
            return t('footer.whatsapp.contact.generic', vw);
        } else {
            return t('footer.whatsapp.contact.product', itemData);
        }
    }, [vw, item]);


    const whatsappMessage = useCreation(() => {
        if (vw === undefined) {
            return undefined;
        } else if (itemData === undefined) {
            return encodeURIComponent(`https://by.filkers.com/vw/${vw.uid}/index.html\n\n${t('footer.whatsapp.message.generic', vw)}`);
        } else {
            return encodeURIComponent(`https://by.filkers.com/vw/${vw.uid}/${item.uid}/index.html\n\n${t('footer.whatsapp.message.product', itemData)}`);
        }
    }, [vw, item]);

    const whatsappClickHandler = useCallback((event) => {
        event.stopPropagation();
        ReactGA.event({
            category: 'VirtualWindow',
            action: 'Whtsapp button click',
            dimension1: vw.uid,
            dimension2: vw.content === undefined ? undefined : vw.content.uid,
            dimension3: item === undefined ? undefined : item.uid
        });

        window.open(`https://api.whatsapp.com/send?phone=${vw.whatsappPhoneNumber}&text=${whatsappMessage}`, '_blank');
    }, [vw, item, whatsappMessage])

    if (vw === undefined || vw.whatsappEnabled !== true) {
        return (
            <div className="page-footer"></div>

        );
    }

    /*
            <a
            href={}
            target="_blank"
            rel="noreferrer"
        >

     */
    return (
        <div
            className="page-footer flk-clickable-item"
            onClick={whatsappClickHandler}
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end"
            }}
        >

            <span className="flk-contact-text" style={{marginRight: "1vh"}}>
                {contactText}
            </span>

            <div style={{width: "20%"}}>
                <WhatsApp/>
            </div>

        </div>
    )


}

export default Footer;
